module.exports = __webpack_public_path__ + "static/restaurant-322061cddab04199ee7cf60955b1a3fb.jpg";